// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ExternalEditorContent-modulewrapper1dY","playerWrapper":"ExternalEditorContent-moduleplayerWrapper1t5"};